<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";

/**
 * Notification Service Settings Page
 */
export default {
  page() {
    return {
      title: this.title,
      meta: [{ name: "description" }],
    };
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "Notification Service",
      items: [],
      loading: false,
      userinfo: null,
      notifysetting: {
        type: 'email',
        email: {
          status: 0,
          address: ''
        },
        whatsapp: {
          status: 0,
          user: ''
        }
      },
      submitLoading: false,
    };
  },
  mounted() {
    this.title = this.$t("menuitems.clouds.notify.text");
    this.items = [
      {
        text: this.$t("menuitems.clouds.text"),
        href: "/",
      },
      {
        text: this.$t("menuitems.clouds.notify.text"),
        active: true,
      },
    ];

    try {
      this.userinfo = JSON.parse(localStorage.getItem("user"));
      if (!this.userinfo) {
        this.$message.error(this.$t("global.errors.loginrequired"));
        this.$router.push({ name: "login" });
        return;
      }
    } catch (error) {
      console.error("解析用户信息失败:", error);
      this.$message.error(this.$t("global.errors.loginrequired"));
      this.$router.push({ name: "login" });
      return;
    }

    this.getnotifysetting();
  },
  methods: {
    getnotifysetting() {
      this.loading = true;
      this.$axios
        .post(
          this.apiuri,
          {
            action: "getnotifysetting",
          },
          {
            headers: { Openid: this.userinfo.openid },
          }
        )
        .then((response) => {
          this.loading = false;
          if (response.data.status === 200 && response.data.data) {
            this.notifysetting = {
              type: response.data.data.type || 'email',
              email: response.data.data.email || {
                status: 0,
                address: ''
              },
              whatsapp: response.data.data.whatsapp || {
                status: 0,
                user: ''
              }
            };
          } else {
            this.$message.error(response.data.msg || response.data.message || this.$t("global.errors.loaddata"));
          }
        })
        .catch((error) => {
          this.loading = false;
          console.error("获取通知设置失败:", error);
          this.$message.error(this.$t("global.errors.network"));
        });
    },
    init_notify() {
      this.notifysetting = {
        type: 'email',
        email: {
          status: 0,
          address: ''
        },
        whatsapp: {
          status: 0,
          user: ''
        }
      };
      this.savenotifysetting();
    },
    savenotifysetting() {
      this.submitLoading = true;
      this.$axios
        .post(
          this.apiuri,
          {
            action: "savenotifysetting",
            data: this.notifysetting,
            type: this.notifysetting.type
          },
          {
            headers: { Openid: this.userinfo.openid },
          }
        )
        .then((response) => {
          this.submitLoading = false;
          if (response.data.status === 200) {
            this.$message({
              message: response.data.msg || this.$t("global.success"),
              type: "success",
            });
            this.getnotifysetting();
          } else {
            this.$message.error(response.data.msg || response.data.message || this.$t("global.errors.operation"));
          }
        })
        .catch((error) => {
          this.submitLoading = false;
          console.error("保存通知设置失败:", error);
          this.$message.error(this.$t("global.errors.network"));
        });
    },
    handleClick(tab) {
      // 切换 tab 时更新 type
      if (tab && tab.name) {
        this.notifysetting.type = tab.name;
      }
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <el-card class="box-card" v-loading="loading">
          <div slot="header" class="clearfix">
            <span>
              <i class="el-icon-message"></i>
              {{ $t("menuitems.clouds.notify.text") }}
            </span>
          </div>
          <div v-if="notifysetting && notifysetting.type">
            <el-tabs v-model="notifysetting.type" @tab-click="handleClick">
              <el-tab-pane 
                v-if="notifysetting && notifysetting.email" 
                :label="$t('clouds.notify.email')" 
                name="email"
              >
                <el-alert 
                  :title="$t('clouds.notify.emailalert', { email: 'noreply@aicoiot.com' })" 
                  type="warning"
                  :closable="false"
                  show-icon
                  style="margin-bottom: 20px"
                ></el-alert>

                <el-form 
                  ref="emailForm" 
                  :model="notifysetting.email" 
                  label-width="120px"
                  label-position="left"
                >
                  <el-form-item :label="$t('clouds.notify.enable')">
                    <el-switch 
                      :active-value="1" 
                      :inactive-value="0" 
                      v-model="notifysetting.email.status"
                      :active-text="$t('global.text.yes')"
                      :inactive-text="$t('global.text.no')"
                    ></el-switch>
                    <div class="form-item-tip">
                      <small class="text-muted">{{ $t("clouds.notify.enable_tip") || "开启或关闭邮件通知服务" }}</small>
                    </div>
                  </el-form-item>
                  <el-form-item :label="$t('clouds.notify.emailaddress')">
                    <el-input 
                      v-model="notifysetting.email.address"
                      :placeholder="$t('clouds.notify.emailaddress_placeholder') || '请输入邮箱地址'"
                      type="email"
                      clearable
                    ></el-input>
                    <div class="form-item-tip">
                      <small class="text-muted">{{ $t("clouds.notify.emailaddress_tip") || "接收通知的邮箱地址" }}</small>
                    </div>
                  </el-form-item>
                  <el-form-item>
                    <el-button 
                      type="primary" 
                      @click="savenotifysetting"
                      :loading="submitLoading"
                      icon="el-icon-check"
                    >{{ $t("device.hd.save") }}</el-button>
                    <el-button 
                      @click="getnotifysetting"
                      icon="el-icon-refresh"
                    >{{ $t("global.button.cancel") }}</el-button>
                  </el-form-item>
                </el-form>
              </el-tab-pane>
            </el-tabs>
          </div>
          <div v-else class="text-center">
            <el-result icon="info" :title="$t('clouds.notify.not_initialized') || '通知服务未初始化'">
              <template slot="extra">
                <el-button type="primary" @click="init_notify" icon="el-icon-setting">
                  {{ $t("clouds.notify.init") }}
                </el-button>
              </template>
            </el-result>
          </div>
        </el-card>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.form-item-tip {
  margin-top: 5px;
}

.box-card {
  margin-bottom: 20px;
}

.clearfix {
  font-weight: 500;
}

.clearfix i {
  margin-right: 5px;
}
</style>